import { useEffect, useRef } from "react";
import "./Mask.css";
import { DivRef } from "../../utils/typesAndMaps";

interface MaskProps {
  hideSettingsOrPanel: () => void
}

export default function Mask({ hideSettingsOrPanel }: MaskProps) {
  const maskRef: DivRef = useRef(null);
  useEffect(() => {
    const maskRefCurrent = maskRef.current;
    maskRefCurrent!.addEventListener("click", hideSettingsOrPanel);
    return () => {
      maskRefCurrent!.removeEventListener("click", hideSettingsOrPanel);
    }
  }, [hideSettingsOrPanel])
  return (
    <div className="dbr-mask" ref={maskRef}></div>
  )
}